// eslint-disable-next-line
export default {
  fetchProjects: () =>
    new Promise((resolve, reject) =>
      resolve([
        // {
        //   id: "C4ADS Analyst Dashboard",
        //   name: "C4ADS Analyst Dashboard",
        //   subtitle: "Data Visualization",
        //   description:
        //     "C4ADS Analyst Dashboard",
        //   links: [
        //     {
        //       url: "https://beta.seamlesshorizons.com/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: [
        //     "React",
        //     "MUI",
        //     "Redux",
        //     "Node.js"
        //   ],
        //   imgSmall: "images/project/seho.jpg",
        //   img: "images/project/seho.jpg",
        //   highlight: true
        // },
        {
          id: "metaagent",
          name: "MetaAgent",
          subtitle: "3D Real Estate Virtual Assistants",
          description: "",
          links: [
            {
              url: "https://meta-assistant-app.web.app/",
              name: "Open the website",
              icon: "fas fa-external-link-alt",
            },
          ],
          secondaryLinks: [],
          labels: ["React", "Three.js", "AWS Sumerian", "Matterport", "Blender", "Unity"],
          imgSmall: "/images/project/metaagent.jpg",
          img: "/images/project/metaagent.jpg",
          highlight: true,
        },
        {
          id: "EarlyVision",
          name: "EarlyVision",
          subtitle: "Online 3D product Configurator",
          description: "Built 3D product Configurator with React and Three.js",
          links: [
            {
              url: "https://earlyvision-configurator.vercel.app/",
              name: "Open the website",
              icon: "fas fa-external-link-alt",
            },
          ],
          secondaryLinks: [],
          labels: ["React", "Zendesk", "Firebase", "Three.js"],
          imgSmall: "/images/project/earlyvision.jpg",
          img: "/images/project/earlyvision.jpg",
          highlight: true,
        },
        {
          id: "Wildlife Seizure Dashboard",
          name: "Wildlife Seizure Dashboard",
          subtitle: "Data Visualization",
          description:
            "Wildlife Seizure Dashboard",
          links: [
            {
              url: "https://wildlifedashboard.c4ads.org/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: [
            "React",
            "Primereact",
            "Rechart",
            "Map",
            "Node.js"
          ],
          imgSmall: "images/project/ecfc.jpg",
          img: "images/project/ecfc.jpg",
          highlight: true
        },
        {
          id: "Zoned out",
          name: "Zoned out",
          subtitle: "Data Visualization",
          description:
            "An Interactive Impact Evaluation of Mekong Economic Development Zones",
          links: [
            {
              url: "https://mekong.c4ads.org/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["React", "Material UI", "DeckGL", "Mapbox", "Node.js"],
          imgSmall: "images/project/zonedout.jpg",
          img: "images/project/zonedout.jpg",
          highlight: true
        },
        {
          id: "Ocelli",
          name: "Ocelli",
          subtitle: "Data Visualization",
          description:
            "An interactive geospatial dataset that documents open source evidence of the systematic displacement and genocide of the Rohingya ethnic minority in Myanmar's Rakhine state",
          links: [
            {
              url: "https://ocelli.c4ads.org/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["React", "DeckGL", "Mapbox", "Node.js"],
          imgSmall: "images/project/ocelli.jpg",
          img: "images/project/ocelli.jpg",
          highlight: true
        },
        {
          id: "Fuel Shipment Map",
          name: "Fuel Shipment Map",
          subtitle: "DataViz - Interactive Fuel Shipment Map",
          description:
            "The interactive map shows shipment route with Yemen from other countires. The data is time series data, and added the playable timeline.",
          links: [
            {
              url: "https://yemen-fuel-map.web.app/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["DeckGL", "Map", "Mapbox", "React", "D3.js", "DataViz"],
          imgSmall: "images/project/yemenfuelmap.jpg",
          img: "images/project/yemenfuelmap.jpg",
          highlight: true
        },
        {
          id: "Trade Map",
          name: "Trade Map",
          subtitle: "DataViz - Interactive Trade Map",
          description:
            "The interactive map shows trade route with Libya from other countires. The data is time series data, and added the playable timeline.",
          links: [
            {
              url: "https://c4ads-libya-trade-map.web.app/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["DeckGL", "Map", "Mapbox", "React", "D3.js", "DataViz"],
          imgSmall:
            "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/d1/1160340/829e0c24bdc69a076b94e91d34d0c7fe-original.JPG",
          img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/d1/1160340/829e0c24bdc69a076b94e91d34d0c7fe-original.JPG",
          highlight: true
        },
        {
          id: "Route Tool",
          name: "Route Tool",
          subtitle: "DataViz - Interactive Route Map",
          description:
            "This is to take some flight route data and create a single page visualization that renders the flight route selected with some summary statistics about wildlife trafficking along that route, and any other route that was also used in conjunction with that route to traffic wildlife. The user will have two filters on the left side of the screen and will select two cities for origin and destination. Then all instances of wildlife trafficking will list on the right side of the screen and the user can see specifics related to trafficking along that particular route.",
          links: [
            {
              url: "http://d25wluwm378t31.cloudfront.net/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["DeckGL", "Map", "Mapbox", "React", "D3.js", "DataViz"],
          imgSmall:
            "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/ea/1160344/d57b243c0f7524a05280eedc953a3ad3-original.JPG",
          img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/ea/1160344/d57b243c0f7524a05280eedc953a3ad3-original.JPG",
          highlight: true
        },
        {
          id: "Country Profile",
          name: "Country Profile",
          subtitle: "DataViz - Interactive Globe",
          description:
            "The interactive Country Profile Map provides an overview of the wildlife seizures made in airports around the world by country.",
          links: [
            {
              url: "https://d327zvdnkttgtq.cloudfront.net/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Amcharts", "React", "D3.js", "DataViz"],
          imgSmall:
            "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/f5/1160355/62f695c23a8138f97f8b3d3fa03c2769-original.JPG",
          img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/f5/1160355/62f695c23a8138f97f8b3d3fa03c2769-original.JPG",
          highlight: true
        },
        {
          id: "ConflictID",
          name: "ConflictID",
          subtitle: "Data visualization",
          description:
            "ConflictID is a project to collect, identify, and analyze images of weapons in conflict, starting with South Sudan. By curating this publicly available imagery, C4ADS hopes to empower data-driven decision making in response to conflict.",
          links: [
            {
              url: "https://conflict.id/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Vue.js", "D3.js", "DataViz"],
          imgSmall: "images/project/conflict.jpg",
          img: "images/project/conflict.jpg",
          highlight: true
        },
        {
          id: "Routes Dashboard",
          name: "Routes Dashboard",
          subtitle: "Interactive Wildlife Seizure Dashboard",
          description:
            "The ROUTES Dashboard is an interactive website providing graphics on wildlife trafficking through airports between 2009 and 2020. The Dashboard’s graphics are derived from open source wildlife seizure data collected by C4ADS under the ROUTES Partnership.",
          links: [
            {
              url: "http://www.routesdashboard.org/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["R", "Vue.js", "D3.js", "DataViz", "Amcharts"],
          imgSmall:
            "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/b7/1160361/3970e70b468f3d499038bc2a3c8a56ea-original.JPG",
          img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/b7/1160361/3970e70b468f3d499038bc2a3c8a56ea-original.JPG",
          highlight: true
        },
        {
          id: "Sanctions Explorer",
          name: "Sanctions Explorer",
          subtitle: "Explore 24 years of OFAC Sanctions Data",
          description:
            "7,100+ entries across the SDN, SSI, FSE, and more. Updated < 5 minutes ago.",
          links: [
            {
              url: "https://sanctionsexplorer.org/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Python", "Node.js", "ExpressJS", "Nginx"],
          imgSmall: "https://i.ibb.co/tZZGyXN/dfsf.jpg",
          img: "https://i.ibb.co/tZZGyXN/dfsf.jpg",
          highlight: true
        },
        {
          id: "Willow Walk",
          name: "Willow Walk",
          subtitle: "3D website for apartment sellers",
          description:
            "Built the elegant 3D website with React and React-three-fiber.",
          links: [
            {
              url: "https://d1oci14bbx7oca.cloudfront.net/finder",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: [
            "Real Estate",
            "React",
            "Three.js",
            "Framer-motion",
            "React-spring"
          ],
          imgSmall: "images/project/willowwalk.jpg",
          img: "images/project/willowwalk.jpg",
          highlight: true
        },
        {
          id: "Park151",
          name: "Park151",
          subtitle: "3D website for apartment sellers",
          description:
            "Built the elegant 3D website with React and React-three-fiber.",
          links: [
            {
              url: "https://www.park151.app",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: [
            "Real Estate",
            "React",
            "Three.js",
            "Framer-motion",
            "React-spring"
          ],
          imgSmall: "images/project/park151.jpg",
          img: "images/project/park151.jpg",
          highlight: true
        },
        {
          id: "Coronation Square",
          name: "Coronation Square",
          subtitle: "3D Website for real estate company",
          description:
            "Built the elegant 3D website with React and React-three-fiber.",
          links: [
            {
              url: "https://www.coronationsquare.london/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: [
            "Real Estate",
            "React",
            "Three.js",
            "Framer-motion",
            "React-spring"
          ],
          imgSmall: "images/project/coronation.jpg",
          img: "images/project/coronation.jpg",
          highlight: true
        },
        {
          id: "New Mansion Square",
          name: "New Mansion Square",
          subtitle: "3D Website for real estate company",
          description:
            "Built the elegant 3D website with React and React-three-fiber.",
          links: [
            {
              url: "http://www.newmansionsquare.london/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: [
            "Real Estate",
            "React",
            "Three.js",
            "Framer-motion",
            "React-spring"
          ],
          imgSmall: "images/project/nmsq.jpg",
          img: "images/project/nmsq.jpg",
          highlight: true
        },
        // {
        //   id: "Genesis Configurator",
        //   name: "Genesis Configurator",
        //   subtitle: "Online 3D Car Configurator for Genesis",
        //   description: "Built shaders for realistic render pipeline with GLSL.",
        //   links: [
        //     {
        //       url: "https://www.genesis.com/us/en/2019/genesis-g70.html/#/car-configurator/G70/792NAF00",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["WebGL", "GLSL", "3dsMax"],
        //   imgSmall:
        //     "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/14/1123421/7bceb09a9186ea8a733e85851dc58ae5-original.JPG",
        //   img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/14/1123421/7bceb09a9186ea8a733e85851dc58ae5-original.JPG",
        //   highlight: true
        // },
        // {
        //   id: "Panasonic CES 2020",
        //   name: "Panasonic CES 2020",
        //   subtitle: "",
        //   description: "Built the Panasonic CES 2020 with Three.js and React",
        //   links: [
        //     {
        //       url: "https://na.panasonic.com/explore",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [
        //     {
        //       url: "https://vimeo.com/558682034",
        //       name: "Watch a 3D carousel",
        //       icon: "fas fa-video"
        //     },
        //     {
        //       url: "https://vimeo.com/558678749",
        //       name: "Watch a car interior",
        //       icon: "fas fa-video"
        //     },
        //     {
        //       url: "https://vimeo.com/558683280",
        //       name: "Watch a timeline",
        //       icon: "fas fa-video"
        //     }
        //   ],
        //   labels: ["React", "Three.js", "3dsMax"],
        //   imgSmall:
        //     "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/519eac8d-b139-490f-bf3e-a84dad570030.gif?ClientID=vimeo-core-prod&Date=1622752908&Signature=c75327eb093798bffdcf74df6574cbcafca383d0",
        //   img: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/519eac8d-b139-490f-bf3e-a84dad570030.gif?ClientID=vimeo-core-prod&Date=1622752908&Signature=c75327eb093798bffdcf74df6574cbcafca383d0",
        //   highlight: true
        // },
        // {
        //   id: "Squareterra",
        //   name: "Squareterra",
        //   subtitle: "Real estate transaction",
        //   description: "Built backend with Django and frontend with React",
        //   links: [
        //     {
        //       url: "https://squareterra.com",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt",
        //     },
        //   ],
        //   secondaryLinks: [],
        //   labels: ["Django", "React"],
        //   imgSmall:
        //     "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/89/1223607/f6c1527231aefde92b56c40d9965a814-original.png",
        //   img:
        //     "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/89/1223607/f6c1527231aefde92b56c40d9965a814-original.png",
        //   highlight: true,
        // },
        // {
        //   id: "IFC Tool",
        //   name: "IFC Tool",
        //   subtitle: "Web-based IFC Tool with powerful drawing tools",
        //   description:
        //     "This project is in progress. IFC 3D viewer with powerful drawing tools. It provides convenient face-to-face, optimization tools, and practical shortcuts for users. Simulation of multiple axes for the model during the development process and provides an efficient manipulation of the building parts. Provides a simple and powerful simulation that can be used by non-professional users. we offer a 2d & 3d drawing tool that can expect huge success with simple operations like Paint or SketchUp. It supports powerful tools to convert your 2d environment to a 3d environment. Compatible with the 3D BIM Viewer tool, it gives you the ability to update project progress, collaboration with co-workers, and the status of your working place in real time.",
        //   links: [
        //     {
        //       url: "https://vimeo.com/558687304",
        //       name: "Watch the old version",
        //       icon: "fas fa-video"
        //     },
        //     {
        //       url: "https://vimeo.com/558684710",
        //       name: "Watch the new version",
        //       icon: "fas fa-video"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["XeoGL", "Three.js", "Angular", "Firebase"],
        //   imgSmall:
        //     "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/140fea5d-8770-4a5e-83ba-48656620453d.gif?ClientID=vimeo-core-prod&Date=1622748446&Signature=ac9840422cd3eaa809de4f63ac72b5c841a023d8",
        //   img: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/140fea5d-8770-4a5e-83ba-48656620453d.gif?ClientID=vimeo-core-prod&Date=1622748446&Signature=ac9840422cd3eaa809de4f63ac72b5c841a023d8",
        //   highlight: true
        // },
        {
          id: "Carport",
          name: "Carport",
          subtitle: "Online Carport Configurator",
          description: "Built Carport configurator with Three.js and React.",
          links: [
            {
              url: "https://designer.carport1.com/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Three.js", "React"],
          imgSmall: "images/project/carport.jpg",
          img: "images/project/carport.jpg",
          highlight: true
        },
        {
          id: "Shirt configurator",
          name: "Shirt configurator",
          subtitle: "Online 3D Shirt Configurator",
          description: "Built 3D shirt configurator with Three.js",
          links: [
            {
              url: "https://centric-shirt-configurator.vercel.app/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Three.js", "React", "PrimeReact", "Styled-components"],
          imgSmall:
            "images/project/shirtconf.jpg",
          img: "images/project/shirtconf.jpg",
          highlight: true
        },
        {
          id: "Kozikaza Planner",
          name: "Kozikaza Planner",
          subtitle: "Online 2D/3D Home Planner",
          description:
            "Built the powerful engine that turn the 2D image floor plan into a 3D floor plan. Instead of drawing out the floor plan from scratch, which is time-consuming, see the floor plan software that automatically converts 2D floor plan images to 3D floor plans that you can edit.",
          links: [
            {
              url: "https://www.kozikaza.com/en/kazaplan/new/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["WebGL", "Babylon.js", "Angular"],
          imgSmall:
            "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/fb/1126032/9e0ca4dc6e6e232bd52cdd27086a69c4-original.JPG",
          img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/fb/1126032/9e0ca4dc6e6e232bd52cdd27086a69c4-original.JPG",
          highlight: true
        },
        {
          id: "Warehouse configurator",
          name: "Warehouse configurator",
          subtitle: "Online 3D Warehouse Configurator for Logiqs B.V.",
          description:
            "Built 3D automatic warehouse configurator with Babylon.js.",
          links: [
            {
              url: "https://asrs.logiqs3d.nl/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Babylon.js", "PHP", "MySQL"],
          imgSmall:
            "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/8f/1123423/cd444cb21d38527189f331b74f7c6a16-original.JPG",
          img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/8f/1123423/cd444cb21d38527189f331b74f7c6a16-original.JPG",
          highlight: true
        },
        // {
        //   id: "Greenhouse configurator",
        //   name: "Greenhouse configurator",
        //   subtitle: "Online 3D Greenhouse Configurator for Logiqs B.V.",
        //   description:
        //     "Built 3D automatic greenhouse layout configurator with Babylon.js.",
        //   links: [
        //     {
        //       url: "https://configurator.greenhousebenching.nl/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["Babylon.js", "PHP", "MySQL", "3dsMax"],
        //   imgSmall:
        //     "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/2e/1160125/f7c9af6bd0b564c167d7473d06f0ab2a-original.JPG",
        //   img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/2e/1160125/f7c9af6bd0b564c167d7473d06f0ab2a-original.JPG",
        //   highlight: true
        // },
        {
          id: "Animascode",
          name: "Animascode",
          subtitle: "3D Product Configurator",
          description: "Built web 3D product configurator with Babylon.js.",
          links: [
            {
              url: "https://animascode.bespokefactory.com/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["Babylon.js", "React", "ASP.NET", "Azure", "Cinema4D"],
          imgSmall: "images/project/animascode.jpg",
          img: "images/project/animascode.jpg",
          highlight: true
        },
        // {
        //   id: "Terrida",
        //   name: "Terrida",
        //   subtitle: "Online Bag Configurator",
        //   description: "Built bag configurator with WebGL.",
        //   links: [
        //     {
        //       url: "https://configurator.terrida.com/configurator/atleta/1310_borsone_sport/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["WebGL", "Babylon.js", "GSAP", "Shader", "Blender"],
        //   imgSmall:
        //     "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/eb/1160325/305c484723d11694023584de5ba7adce-original.JPG",
        //   img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/eb/1160325/305c484723d11694023584de5ba7adce-original.JPG",
        //   highlight: true
        // },
        // {
        //   id: "3DL",
        //   name: "3DL",
        //   subtitle: "Built the training 3D Web App with Three.js and Node.js",
        //   description:
        //     "3DL is a visual and interactive teaching and learning platform with content that is suitable for students across different school grades. It helps teachers to engage students better. Students are able to EXPLORE, EXAMINE and EXPLAIN using 3D Models, Videos, Animations and a range of other activities.",
        //   links: [
        //     {
        //       url: "https://tdl-app.herokuapp.com/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [
        //     {
        //       url: "https://www.microsoft.com/en-us/p/3dl/9nbmlv7xhj3n?rtc=1&activetab=pivot%3Aoverviewtab/",
        //       name: "Learn more on the app's site (Unity3D App)",
        //       icon: "fab fa-windows"
        //     }
        //   ],
        //   labels: ["Three.js", "Node.js", "MongoDB", "CMS", "Unity3D"],
        //   imgSmall: "images/project/3dl.jpg",
        //   img: "images/project/3dl.jpg",
        //   highlight: true
        // },
        // {
        //   id: "tsuyoshi.in",
        //   name: "tsuyoshi.in",
        //   subtitle: "Interactive 3D website",
        //   description:
        //     "Built the material of crystals with GLSL and the animation with Greensock",
        //   links: [
        //     {
        //       url: "https://tsuyoshi.in/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["WebGL", "Three.js", "GLSL", "GSAP", "3dsMax"],
        //   imgSmall:
        //     "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/74fc4526-7eae-4f0c-8ccc-dee8d7c17c28.gif?ClientID=vimeo-core-prod&Date=1622877790&Signature=94d92ae50726ae48a2fe6361fcecb5dec798a148",
        //   img: "https://videoapi-muybridge.vimeocdn.com/animated-thumbnails/image/74fc4526-7eae-4f0c-8ccc-dee8d7c17c28.gif?ClientID=vimeo-core-prod&Date=1622877790&Signature=94d92ae50726ae48a2fe6361fcecb5dec798a148",
        //   highlight: true
        // },
        // {
        //   id: "3D showcase",
        //   name: "3D showcase",
        //   subtitle: "Data 3D Visualization",
        //   description:
        //     "A WebGL piece done for a client, this 3D photo directory was used as a showcase piece at a event in Netherlands, where this was shown on a gorgeous event screen the width of a banquet hall.",
        //   links: [
        //     {
        //       url: "https://belopot.github.io/member-showcase/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [
        //     {
        //       url: "https://github.com/belopot/member-showcase/",
        //       name: "Open the project",
        //       icon: "fab fa-github"
        //     }
        //   ],
        //   labels: ["DataViz", "WebGL", "Three.js", "GSAP"],
        //   imgSmall:
        //     "https://github.com/belopot/member-showcase/raw/master/screenshots/0.gif",
        //   img: "https://github.com/belopot/member-showcase/raw/master/screenshots/0.gif",
        //   highlight: true
        // },
        // {
        //   id: "Bubble Animation",
        //   name: "Bubble Animation",
        //   subtitle: "Bubble Animation",
        //   description: "Built bubble animation with GLSL and Three.js.",
        //   links: [],
        //   secondaryLinks: [
        //     {
        //       url: "https://github.com/belopot/bubble-animation-shader/",
        //       name: "Open the project",
        //       icon: "fab fa-github"
        //     }
        //   ],
        //   labels: ["GLSL", "Shader"],
        //   imgSmall:
        //     "https://github.com/belopot/bubble-animation-shader/raw/master/screenshots/0.gif",
        //   img: "https://github.com/belopot/bubble-animation-shader/raw/master/screenshots/0.gif",
        //   highlight: false
        // },
        // {
        //   id: "Path Animation",
        //   name: "Path Animation",
        //   subtitle: "SVG Path Animation in Three.js",
        //   description: "Built svg path animation with GLSL and Three.js.",
        //   links: [
        //     {
        //       url: "https://belopot.github.io/svg-path-animation/dist/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [
        //     {
        //       url: "https://github.com/belopot/svg-path-animation/",
        //       name: "Open the project",
        //       icon: "fab fa-github"
        //     }
        //   ],
        //   labels: ["GLSL", "Shader"],
        //   imgSmall:
        //     "https://github.com/belopot/svg-path-animation/raw/master/screenshots/0.gif",
        //   img: "https://github.com/belopot/svg-path-animation/raw/master/screenshots/0.gif",
        //   highlight: false
        // },
        // {
        //   id: "theyearofgreta",
        //   name: "theyearofgreta",
        //   subtitle: "Personal website for Greta Thunberg",
        //   description: "Built interactive 3D website with Three.js and GSAP.",
        //   links: [
        //     {
        //       url: "https://theyearofgreta.com/",
        //       name: "Open the website",
        //       icon: "fas fa-external-link-alt"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["Three.js", "GSAP", "GLSL", "React"],
        //   imgSmall:
        //     "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/e1/1160252/fd48fa6d402754326f9b4816bccbbdb2-original.JPG",
        //   img: "https://s3.amazonaws.com/poly-screenshots.angel.co/Project/e1/1160252/fd48fa6d402754326f9b4816bccbbdb2-original.JPG",
        //   highlight: true
        // },
        // {
        //   id: "Weapon Viewer",
        //   name: "Weapon Viewer",
        //   subtitle: "Web 3D Weapon Viewer",
        //   description: "Built web 3D weapon viewer with Three.js and ReactJS.",
        //   links: [],
        //   secondaryLinks: [
        //     {
        //       url: "https://github.com/belopot/weapon-viewer/",
        //       name: "Open the project",
        //       icon: "fab fa-github",
        //     },
        //   ],
        //   labels: ["Three.js", "React"],
        //   imgSmall:
        //     "https://github.com/belopot/weapon-viewer/raw/master/public/assets/screenshots/akm.JPG",
        //   img:
        //     "https://github.com/belopot/weapon-viewer/raw/master/public/assets/screenshots/akm.JPG",
        //   highlight: false,
        // },
        // {
        //   id: "Furniture Viewer",
        //   name: "Furniture Viewer",
        //   subtitle: "Web 3D Furniture Viewer",
        //   description:
        //     "Built web 3D furniture viewer with Three.js and ReactJS.",
        //   links: [],
        //   secondaryLinks: [
        //     {
        //       url: "https://github.com/belopot/furniture-viewer/",
        //       name: "Open the project",
        //       icon: "fab fa-github",
        //     },
        //   ],
        //   labels: ["Three.js", "React"],
        //   imgSmall:
        //     "https://github.com/belopot/furniture-viewer/raw/master/screenshots/1.JPG",
        //   img:
        //     "https://github.com/belopot/furniture-viewer/raw/master/screenshots/1.JPG",
        //   highlight: false,
        // },
        // {
        //   id: "Vehicle Configurator",
        //   name: "Vehicle Configurator",
        //   subtitle: "Online 3D Vehicle Configurator",
        //   description: "This project is in progress",
        //   links: [
        //     {
        //       url: "https://vimeo.com/558104676",
        //       name: "Watch the demo",
        //       icon: "fas fa-video"
        //     }
        //   ],
        //   secondaryLinks: [],
        //   labels: ["WebGL", "React", "Node.js", "MongoDB", "CMS"],
        //   imgSmall: "images/project/vehicleconf.jpg",
        //   img: "images/project/vehicleconf.jpg",
        //   highlight: true
        // },
        {
          id: "Interactive Brain",
          name: "Interactive Brain",
          subtitle: "Simulate the signals of brain",
          description: "Built interactive 3D brain with WebGL.",
          links: [
            {
              url: "https://belopot.github.io/interactive-brain/",
              name: "Open the website",
              icon: "fas fa-external-link-alt"
            }
          ],
          secondaryLinks: [],
          labels: ["WebGL", "Three.js", "GLSL", "GSAP", "Shader"],
          imgSmall:
            "https://github.com/belopot/interactive-brain/raw/master/screenshots/0.gif",
          img: "https://github.com/belopot/interactive-brain/raw/master/screenshots/0.gif",
          highlight: true
        },
      ])
    )
}
